export default __webpack_public_path__ + "static/media/schedule-white.2ceccab6.svg";